import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import SetupConfig from "./configs/SetupConfig";
import Routes from "./routes";
import UiModuleProvider from "ui-modules/components/Layout/UiModuleProvider";
import InstallAppPromptIOS from "./components/InstallAppPromptIOS";
import BannerPromotion from "./components/BannerPromotion";

ReactDOM.render(
  <UiModuleProvider>
    <InstallAppPromptIOS />
    <BannerPromotion />
    <Router>
      <SetupConfig />
      <Routes />
    </Router>
  </UiModuleProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
